import { FC } from 'react';

import {
  Block,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
} from 'modules/_shared/components/LayoutV9/block/Block';
import Head from 'modules/_shared/components/LayoutV9/head/Head';
import Page from 'modules/_shared/components/Pages/Page';
import Content from 'modules/_shared/components/LayoutV9/content/Content';
import { PreviewCard } from 'modules/_shared/components/LayoutV9/preview/Preview';
import GoBackButton from 'modules/_shared/components/Buttons/GoBackButton';

const Cookies: FC = () => (
  <Page className="bg-lighter pb-5">
    <Head title="Política de Uso de Cookies" />
    <Content>
      <div className="content-page wide-md m-auto">
        <BlockHead size="lg" wide="xs" className="mx-auto">
          <BlockHeadContent className="text-center">
            {/* @ts-ignore */}
            <BlockTitle tag="h2" className="fw-normal">
              Política de Uso de Cookies
            </BlockTitle>
            {/* @ts-ignore */}
            <BlockDes>
              <p className="lead">Área Privada accionistas</p>
              <p className="text-soft ff-italic">
                Fecha de publicación: 18 marzo de 2025
              </p>
              <GoBackButton hideWhenNoHistory />
            </BlockDes>
          </BlockHeadContent>
        </BlockHead>
        {/* @ts-ignore */}
        <Block>
          {/* @ts-ignore */}
          <PreviewCard className="card-inner">
            <div className="entry">
              <p>
                La página web <a href="http://www.axa.es">www.axa.es</a>{' '}
                responsabilidad de AXA SEGUROS GENERALES, S.A. DE SEGUROS Y
                REASEGUROS con domicilio social en la calle Monseñor Palmer 1 de
                Palma de Mallorca e inscrita en el Registro Mercantil de Palma
                de Mallorca, hoja PM-61041 y C.I.F. número A60917978 utiliza
                cookies propias y de terceros.
              </p>
              <p>
                Consecuentemente, a la utilización de cookies se le aplica la
                presente política que ha sido elaborada con la finalidad de que
                usted, el usuario, quede informado de los distintos tratamientos
                que se llevan a cabo en estos dispositivos y pueda consentir su
                uso de manera informada, de conformidad con lo previsto en la
                legislación vigente.
              </p>
              <p>
                AXA SEGUROS GENERALES, S.A. DE SEGUROS Y REASEGUROS le informa
                de que emplea herramientas que le permiten obtener y disponer de
                información sobre sus acciones, uso y navegación por nuestra
                página web con el objeto de poder mejorar su usabilidad,
                ofrecerle las mejores ofertas de productos o servicios a efectos
                de la futura contratación, analizar y anticipar comportamientos
                fraudulentos, resolver incidencias y analizar errores así como
                para crear perfiles que permitan crear reglas de suscripción y
                tarificación.
              </p>

              <h3 className="mb-3">Información general sobre cookies</h3>
              <p>
                Con carácter general le informamos de que las cookies son un
                mensaje enviado por el servidor al ordenador del usuario
                consistente en ficheros de texto que se almacenan en la memoria
                del ordenador y que recogen información relativa a la página que
                se visita, el tiempo de conexión a Internet, etc. Las cookies
                vuelven a ser enviadas al servidor cada vez que usted entra en
                esa página. Las cookies instaladas por AXA no pueden leer datos
                de su disco duro ni leer los archivos cookie creados por otros
                proveedores.
              </p>
              <p>
                Los logs son unos archivos almacenados en el servidor del editor
                que registran información sobre su navegación y que tienen por
                finalidad analizar el funcionamiento del sistema, localizar las
                incidencias y problemas que puedan surgir y solventarlos en el
                menor plazo posible, seguir ofreciéndole los servicios que
                solicita, conocer mejor sus preferencias y ofrecerle otros
                servicios que puedan adecuarse a sus gustos.
              </p>
              <p>
                La revocación de su consentimiento, en la forma prevista en la
                presente política, o la modificación de las condiciones de
                acceso a las cookies a través de su navegador, conllevará la
                imposibilidad de una correcta navegación y la imposibilidad de
                adecuar nuestro portal a las necesidades específicas del
                usuario.
              </p>

              <h3 className="mb-3">
                Descripción de las tipologías de cookies habitualmente
                utilizadas en internet
              </h3>
              <p>
                A continuación, exponemos una clasificación de las cookies
                habitualmente utilizadas atendiendo a distintas tipologías en
                función de su responsable, el tiempo de permanencia y la
                finalidad de su uso:
              </p>

              <h4 className="mb-2">
                1. Tipos de cookies según la entidad que las gestione:
              </h4>
              <ul className="list mb-4">
                <li>
                  <strong>Cookies propias:</strong> son aquéllas que se envían
                  al equipo terminal del usuario desde un equipo o dominio
                  gestionado por el propio editor y desde el que se presta el
                  servicio solicitado por el usuario.
                </li>
                <li>
                  <strong>Cookies de tercero:</strong> son aquéllas que se
                  envían al equipo terminal del usuario desde un equipo o
                  dominio que no es gestionado por el editor de la web, sino por
                  otra entidad que trata los datos obtenidos a través de las
                  cookies.
                </li>
              </ul>

              <h4 className="mb-2">
                2. Tipos de cookies según el plazo de tiempo que permanecen
                activadas
              </h4>
              <ul className="list mb-4">
                <li>
                  <strong>Cookies de sesión:</strong> son un tipo de cookies
                  diseñadas para recabar y almacenar datos mientras, usted, el
                  usuario accede a una página web. Se suelen emplear para
                  almacenar información que solo interesa conservar para la
                  prestación del servicio solicitado por el usuario en una sola
                  ocasión (p.e. una lista de productos adquiridos).
                </li>
                <li>
                  <strong>Cookies persistentes:</strong> son un tipo de cookies
                  mediante las que los datos siguen almacenados en el terminal y
                  pueden ser accedidos y tratados durante un periodo definido
                  por el editor de la cookie que puede ir de unos minutos a
                  varios años.
                </li>
              </ul>

              <h4 className="mb-2">3. Tipos de cookies según su finalidad:</h4>
              <ul className="list mb-4">
                <li>
                  <strong>Cookies necesarias o técnicas:</strong> son aquellas
                  que permiten al usuario, la navegación en la página, la
                  utilización de servicios básicos como gestión y operativa de
                  la web, el control del tráfico y visitas, el acceso a áreas
                  seguras y restringidas y la realización de formularios de
                  tarificación o contratación. La página web no puede funcionar
                  adecuadamente sin estas cookies. En AXA, existen determinadas
                  cookies técnicas que instalan un identificador único del
                  presupuesto de seguro que realiza el usuario y le permite
                  realizar una tarificación y contratación. Únicamente almacenan
                  el paso en el que se encuentra dentro del proceso de la
                  tarificación. No almacenan otro tipo de información de
                  usuario. Estas cookies se vuelven a instalar cada vez que se
                  realiza un presupuesto en la web y por motivos técnicos tiene
                  un nombre distinto cada vez que es instalada.
                </li>
                <li>
                  <strong>Cookies de preferencia:</strong> son aquéllas que
                  permiten al usuario acceder al servicio con algunas
                  características generales predefinidas en función de una serie
                  de criterios en el terminal del usuario como por ejemplo
                  serían el idioma, el tipo de navegador a través del cual
                  accede al servicio, la configuración regional desde donde
                  accede al servicio, etc.
                </li>
                <li>
                  <strong>Cookies estadísticas:</strong> son aquéllas que
                  permiten al editor de estas, el seguimiento y análisis del
                  comportamiento de los usuarios de los sitios web a los que
                  están vinculadas. La información recogida mediante este tipo
                  de cookies se utiliza en la medición de la actividad de los
                  sitios web, aplicación o plataforma y para la elaboración de
                  perfiles de navegación de los usuarios de dichos sitios,
                  aplicaciones y plataformas, con el fin de introducir mejoras
                  en función del análisis de los datos de uso que hacen los
                  usuarios del servicio.
                </li>
                <li>
                  <strong>Cookies de análisis:</strong> son aquéllas que
                  permiten al editor de estas el seguimiento y análisis del
                  comportamiento de los usuarios de los sitios web a los que
                  están vinculadas. La información recogida mediante este tipo
                  de cookies se utiliza en la medición de la actividad de los
                  sitios web, aplicación o plataforma y para la elaboración de
                  perfiles de navegación de los usuarios de dichos sitios,
                  aplicaciones y plataformas, con el fin de introducir mejoras
                  en función del análisis de los datos de uso que hacen los
                  usuarios del servicio.
                </li>
                <li>
                  <strong>Cookies de marketing:</strong> son aquellas que
                  permiten la gestión, de la forma más eficaz posible, de los
                  espacios publicitarios que, en su caso, el editor haya
                  incluido en una página web, aplicación o plataforma desde la
                  que presta el servicio solicitado. Estas cookies almacenan
                  información del comportamiento de los usuarios obtenida a
                  través de la observación continuada de sus hábitos de
                  navegación, lo que permite desarrollar un perfil específico
                  para mostrar publicidad en función de este.
                </li>
              </ul>

              <h4 className="mb-2">4. Cookies &quot;null&quot;</h4>
              <ul className="list mb-4">
                <li>
                  Si bien queremos informarle que usted como usuario podrá
                  acceder al listado de cookies que ha aceptado al acceder a
                  nuestra página. En el mismo le aparecerá un listado de todas
                  las tipologías de cookies y aquellas que usted ha rechazado,
                  el sistema las bloquea automáticamente dando como resultado
                  que el campo de esta aparezca &quot;vacío&quot; o con la
                  palabra &quot;null&quot;. Es decir, en dichos casos la
                  Compañía no trata ninguna información del usuario atendiendo a
                  su rechazo previo.
                </li>
              </ul>

              <h3 className="mb-3">
                Aceptar, denegar o revocar el consentimiento o cómo eliminar las
                cookies
              </h3>
              <p>
                Usted, en calidad de usuario de esta web, presta su
                consentimiento de manera informada, expresa, libre e inequívoca,
                para la instalación de cookies, a través del botón &quot;Aceptar
                todas las cookies&quot; que aparece en la primera capa
                informativa o bien en base a la selección granular de cada una
                de las tipologías de cookies que ha realizado desde el Gestor de
                cookies &quot;Personalizar&quot;.
              </p>
              <p>
                Si usted clica en el botón de la primera capa &quot;Solo usar
                cookies necesarias&quot;, las cookies no se le instalarán en el
                dispositivo, excepto aquellas que sean técnicas o estrictamente
                necesarias, o de personalización cuando usted tome decisiones
                sobre ellas, actuando en ese caso como cookies técnicas y sin
                que puedan ser utilizadas para otros fines distintos. Al margen
                de dichas cookies técnicas, no se instalará ninguna otra sin su
                previa aceptación.
              </p>
              <p>
                Una vez aceptadas y/o configuradas las cookies, usted puede
                cambiar su consentimiento o retirarlo, haciendo clic en el
                apartado mostrado a continuación donde se indica &quot;Cambiar
                su consentimiento&quot;.
              </p>

              <h3 className="mb-3">
                Configuración de su navegador para el uso de las cookies
              </h3>
              <p>
                Adicionalmente, usted podrá impedir la generación de cookies
                mediante la selección de la correspondiente opción en su
                programa navegador. Para ello deberá acceder a las opciones de
                configuración de privacidad, según el navegador, y seleccionar
                las opciones de gestión de cookies que desee.
              </p>
              <p>Para más información elija entre sus navegadores:</p>
              <ul className="list mb-4">
                <li>
                  Internet Explorer: Herramientas -&gt; Opciones de Internet
                  -&gt; Privacidad -&gt; Configuración. Para más información,
                  puede consultar el soporte de Microsoft{' '}
                  <a href="http://windows.microsoft.com/es-es/windows-vista/block-or-allow-cookies">
                    http://windows.microsoft.com/es-es/windows-vista/block-or-allow-cookies
                  </a>{' '}
                  o la Ayuda del navegador.
                </li>
                <li>
                  Firefox: Herramientas -&gt; Opciones -&gt; Privacidad -&gt;
                  Historial -&gt; Configuración Personalizada. Para más
                  información, puede consultar el soporte de Google{' '}
                  <a href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrearpreferencias">
                    https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrearpreferencias
                  </a>{' '}
                  o la Ayuda del navegador.
                </li>
                <li>
                  Chrome: Configuración -&gt; Mostrar opciones avanzadas -&gt;
                  Privacidad -&gt; Configuración de contenido. Para más
                  información, puede consultar el soporte de Mozilla{' '}
                  <a href="https://support.google.com/accounts/answer/61416?hl=es">
                    https://support.google.com/accounts/answer/61416?hl=es
                  </a>{' '}
                  o la Ayuda del navegador.
                </li>
                <li>
                  Safari: Preferencias -&gt; Seguridad. Para más información,
                  puede consultar el soporte de Apple{' '}
                  <a href="http://support.apple.com/kb/HT1677?viewlocale=es_ES&locale=es_ES">
                    http://support.apple.com/kb/HT1677?viewlocale=es_ES&locale=es_ES
                  </a>{' '}
                  o la Ayuda del navegador.
                </li>
              </ul>

              <h3 className="mb-3">Listado de cookies utilizadas</h3>
              <div className="table-responsive border-top">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Cookie</th>
                      <th>Domain</th>
                      <th>Description</th>
                      <th>Duration</th>
                      <th>Type</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>mp_*_mixpanel</td>
                      <td>axa.sttok.com</td>
                      <td>
                        Mixpanel sets this cookie to determine how users use the
                        website so that a good user experience can be provided.
                      </td>
                      <td>1 year</td>
                      <td>Analytics</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </PreviewCard>
        </Block>

        {/* @ts-ignore */}
        <Block className="d-flex justify-content-center">
          <GoBackButton hideWhenNoHistory />
        </Block>
      </div>
    </Content>
  </Page>
);

export default Cookies;
